/* =========================================================================
   Tiny DOM layer: modal, toast, and the action registry.

   Iteration 1 used inline onclick="..." attributes, which need every handler
   to be a global. ES modules have no globals, so instead each interactive
   element carries data-act="name" and a single delegated listener dispatches
   to the registry. Same amount of code, no window pollution, and it keeps
   working for markup rendered after load.
   ========================================================================= */

const actions = Object.create(null)
const inputActions = Object.create(null)

export function registerActions(map) { Object.assign(actions, map) }
export function registerInputActions(map) { Object.assign(inputActions, map) }

export function initDelegation() {
  document.addEventListener('click', ev => {
    const el = ev.target.closest('[data-act]')
    if (!el) return
    const fn = actions[el.dataset.act]
    if (!fn) return
    // Let real links (source links, mailto) behave normally.
    if (el.tagName === 'A' && el.dataset.passthrough === '1') return

    // Form controls must keep their native behaviour — calling preventDefault
    // on a checkbox click stops it toggling, which silently breaks plan mode.
    const native = el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA'
    if (!native) ev.preventDefault()

    ev.stopPropagation()
    fn(el.dataset, el, ev)
  })

  document.addEventListener('input', ev => {
    const el = ev.target.closest('[data-input-act]')
    if (!el) return
    const fn = inputActions[el.dataset.inputAct]
    if (fn) fn(el.dataset, el, ev)
  })

  // Enter to submit the note / pairing inputs
  document.addEventListener('keydown', ev => {
    if (ev.key !== 'Enter') return
    const el = ev.target.closest('[data-enter-act]')
    if (!el) return
    const fn = actions[el.dataset.enterAct]
    if (fn) { ev.preventDefault(); fn(el.dataset, el, ev) }
  })
}

/* ---------------- modal ---------------- */

let modalCloseHandler = null

export function openModal(html, onClose) {
  document.getElementById('modalContent').innerHTML = html
  document.getElementById('overlay').classList.add('open')
  // [iOS] stop the page behind the sheet scrolling with it
  document.body.classList.add('modal-open')
  modalCloseHandler = onClose || null
}

export function closeModal() {
  document.getElementById('overlay').classList.remove('open')
  document.body.classList.remove('modal-open')
  document.getElementById('modalContent').innerHTML = ''
  const h = modalCloseHandler
  modalCloseHandler = null
  if (h) h()
}

export function isModalOpen() {
  return document.getElementById('overlay').classList.contains('open')
}

/* ---------------- toast ---------------- */

let toastTimer = null

export function toast(msg) {
  const t = document.getElementById('toast')
  t.textContent = msg
  t.classList.add('show')
  clearTimeout(toastTimer)
  toastTimer = setTimeout(() => t.classList.remove('show'), 2600)
}

/* ---------------- misc ---------------- */

export function $(id) { return document.getElementById(id) }

export function val(id) {
  const el = document.getElementById(id)
  return el ? el.value : ''
}
